import { MrbBaseViewStore } from "mrb/core/stores";
import { action, computed, makeObservable } from "mobx";
import { MrbSelectStore } from "mrb/components/select";
import { UUID } from "common/utils";
import { find, findIndex, isNil, isEmpty, filter } from "lodash";

class NakiStoreHomeSectionViewStore extends MrbBaseViewStore {
    @computed get item() {
        return find(this.nakiStoreHomeSectionListViewStore.sections, (section) => section.id === this.id);
    }

    @computed get isAddContentButtonDisabled() {
        return isNil(this.contentSelectStore.selectedItem) || !this.item.isActive || this.selectedItemExists;
    }

    @computed get isSystemSection() {
        return !isEmpty(this.item.systemSectionIdentifier);
    }

    @computed get selectedItemExists() {
        const selectedItem = this.contentSelectStore.selectedItem;
        if (!selectedItem) {
            return false;
        }

        return (
            findIndex(
                this.item.items,
                (x) =>
                    /* eslint-disable eqeqeq */
                    x.podcastId == selectedItem.podcastId &&
                    x.nakiNigunArtistId == selectedItem.nakiNigunArtistId &&
                    x.nakiNigunAlbumId == selectedItem.nakiNigunAlbumId
            ) !== -1
        );
    }

    constructor(rootStore, { nakiStoreHomeSectionListViewStore, id }) {
        super(rootStore);
        this.nakiStoreHomeSectionListViewStore = nakiStoreHomeSectionListViewStore;
        this.routeStore = this.nakiStoreHomeSectionListViewStore.routeStore;
        this.id = id;
        makeObservable(this);

        this.contentSelectStore = new MrbSelectStore({
            isSearchable: true,
            textKey: "title",
            valueKey: "id",
            initFetch: false,
            actions: {
                find: (searchTerm, pageNumber, pageSize) => {
                    return this.routeStore.getContent({
                        search: searchTerm,
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                    });
                },
                mapItem: (item) => {
                    return {
                        label: item.title,
                        value:
                            item.podcastId ||
                            item.nakiNigunArtistId ||
                            item.nakiNigunAlbumId ||
                            item.loadioArtistId ||
                            item.loadioAlbumId,
                        item: item,
                    };
                },
            },
        });
    }

    @action.bound
    setIsActive(value) {
        this.nakiStoreHomeSectionListViewStore.toggleIsActive(this.id, value);
    }

    @action.bound
    onTitleChange(event) {
        this.item.title = event.target.value;
    }

    addItem(item) {
        this.item.items.push(item);
    }

    @action.bound
    onSelectItem() {
        const item = this.contentSelectStore.selectedItem;
        const obj = {
            id: UUID.create(),
            sortOrder: this.item.items.length,
        };
        if (!isNil(item.podcastId)) {
            obj.podcastId = item.podcastId;
            obj.podcast = {
                id: item.podcastId,
                title: item.title,
                isPremium: item.isPremium,
                coverImageId: item.coverImageId,
                podcastType: item.podcastType,
            };
        } else if (!isNil(item.nakiNigunArtistId)) {
            obj.nakiNigunArtistId = item.nakiNigunArtistId;
            obj.nakiNigunArtist = {
                id: item.nakiNigunArtistId,
                name: item.title,
                isPremium: item.isPremium,
                coverImageId: item.coverImageId,
            };
        } else if (!isNil(item.nakiNigunAlbumId)) {
            obj.nakiNigunAlbumId = item.nakiNigunAlbumId;
            obj.nakiNigunAlbum = {
                id: item.nakiNigunAlbumId,
                title: item.title,
                isPremium: item.isPremium,
                coverImageId: item.coverImageId,
            };
        }
        if (this.itemExists(obj)) {
            return;
        }
        this.addItem(obj);
        this.contentSelectStore.clearOptions();
        this.contentSelectStore.clear();
        this.contentSelectStore.filter();
    }

    itemExists(item) {
        if (!item) {
            return false;
        }
        return (
            findIndex(
                this.item.items,
                (x) =>
                    /* eslint-disable eqeqeq */
                    x.podcastId == item.podcastId &&
                    x.nakiNigunArtistId == item.nakiNigunArtistId &&
                    x.nakiNigunAlbumId == item.nakiNigunAlbumId
            ) !== -1
        );
    }

    @action.bound
    deleteSection() {
        this.nakiStoreHomeSectionListViewStore.deleteSection(this.id);
    }

    @action.bound
    deleteItem(id) {
        this.item.items = filter(this.item.items, (item) => item.id !== id);
    }
}

export default NakiStoreHomeSectionViewStore;
